import React from 'react';

import copy from 'copy-to-clipboard';
import { useTranslation } from 'react-i18next';

import { bemCssModules, getTestId } from '@utils';

import { notificationsActions, useStore } from '@modules';
import { NotificationTypesEnum } from '@modules/notifications/types';

import CopyField from '@components/CopyField';

import CopyIcon from './copy.svg';

import style from './AccountDetails.scss';

const cn = bemCssModules(style, 'AccountDetails');
const ti = getTestId('AccountDetails');

const { toast } = NotificationTypesEnum;

export type TAccountDetails = {
  fields: { caption: string; text: string }[];
  className?: string;
};

const AccountDetails: CustomFC<TAccountDetails> = ({ className, fields }) => {
  const { t } = useTranslation();
  const [, dispatch] = useStore();

  const allFieldsString = fields.map(({ text }) => text).join('\n');

  const handleCopy = () => {
    copy(allFieldsString);
    dispatch(notificationsActions.add({ message: t('operations.copied'), type: toast }));
  };

  return (
    <div className={cn(null, [className])} data-testid={ti()}>
      <div className={cn('header')}>
        <h3 className={cn('title')} data-testid={ti('title')}>
          {t('iban.account_details.title')}
        </h3>
        <button
          type="button"
          className={cn('button')}
          onClick={handleCopy}
          data-testid={ti('copy-button')}
        >
          {t('public.all')}
          <CopyIcon className={cn('icon')} />
        </button>
      </div>

      {fields.map(({ caption, text }) => (
        <CopyField key={caption} caption={caption} value={text} />
      ))}
    </div>
  );
};

export default AccountDetails;
